import { z } from 'zod';

/** How many stickers a new batch can have. */
export const STICKER_BATCH_MAX = 1000;
export const STICKER_BATCH_PRESETS = [10, 50, 100, 200] as const;

/** Light: white sticker. Dark: the night version, for dark charger bodies. */
export const STICKER_THEMES = ['light', 'dark'] as const;
export type StickerTheme = (typeof STICKER_THEMES)[number];

/** Make a batch of new stickers, not on any charger yet, ready for printing. */
export const stickerBatchBody = z.object({
  count: z.coerce.number().int('A whole number').min(1, 'At least 1').max(STICKER_BATCH_MAX, `At most ${STICKER_BATCH_MAX}`),
});
export type StickerBatchBody = z.input<typeof stickerBatchBody>;

/** Sticker PDFs to download: one PDF, or a zip of one PDF per sticker. */
export const stickerDownloadBody = z.object({
  ids: z.array(z.string().uuid()).min(1, 'Choose at least one sticker').max(STICKER_BATCH_MAX),
  theme: z.enum(STICKER_THEMES),
});
export type StickerDownloadBody = z.input<typeof stickerDownloadBody>;

/** One QR sticker in the list. */
export interface QrSticker {
  id: string;
  /** Six characters, without the dash. */
  code: string;
  batch: number | null;
  createdAt: string;
  downloadedAt: string | null;
  /** The socket it's on; null while it's not used yet. */
  charger: { id: string; name: string; siteName: string; organisationName: string; organisationSiteCount: number; connectorId: number; connectorCount: number; isActive: boolean } | null;
}

/** Delete several stickers at once. */
export const stickerDeleteBody = z.object({
  ids: z.array(z.string().uuid()).min(1, 'Choose at least one sticker').max(5000),
});
export type StickerDeleteBody = z.input<typeof stickerDeleteBody>;
